import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import GradeTable from '../pages/Apparaisal/GradeTable';
import PrimaryCategoryTable from '../pages/Apparaisal/PrimaryCategoryTable';
import TemplateTable from '../pages/Apparaisal/TemplateTable';
import DataTable from './DataTable';

function CreateTemplateTab() {
  return (
    <Tabs
      defaultActiveKey="home"
      id="justify-tab-example"
      className="mb-3 tempactive"
      justify
    >
      <Tab eventKey="home" title="Grade Level" className="custom-tab">
      
      <GradeTable/>
      </Tab>
      <Tab  eventKey="profile"  title="Primary Category" className="custom-tab">

      <PrimaryCategoryTable/>
      </Tab>
      <Tab eventKey="longer-tab" title="Template">
     <TemplateTable/>
      </Tab>
     
    </Tabs>
  );
}

export default CreateTemplateTab;